import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import RSVP from 'rsvp';

class ResourcesRoute extends Route {
  @service router;
  @service store;

  beforeModel() {
    this.router.on('routeDidChange', this.redirectToInnerPage);
    this.router.on('routeWillChange', this.blockInnerToParentPage);
  }

  redirectToInnerPage = (transition) => {
    if (transition?.to?.name === 'resources.index')
      this.router.transitionTo('resources.people');
  };

  blockInnerToParentPage = (transition) => {
    if (
      transition?.to?.name === 'resources.index' &&
      ['resources.people'].includes(transition?.from?.name)
    )
      transition.abort();
  };

  resetController(controller, isExiting, transition) {
    if (isExiting && transition.targetName !== 'error') {
      this.router.off('routeDidChange', this.redirectToInnerPage);
      this.router.off('routeWillChange', this.blockInnerToParentPage);
    }
  }

  model() {
    return RSVP.hash({
      people: {
        active: this.store.query('person', {
          filter: {
            active: true,
          },
        }),
        inactive: this.store.query('person', {
          filter: {
            active: false,
          },
        }),
      },
    });
  }
}

export default instrumentRoutePerformance(ResourcesRoute);
